import { toScheduledFromIsoFromPickerDate } from './toScheduledFromIsoFromPickerDate';
import { toScheduledToIsoFromPickerDate } from './toScheduledToIsoFromPickerDate';

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export function normalizeRoutesScheduledFilterValue(
  value: string,
  bound: 'from' | 'to'
): string {
  const trimmed = value.trim();
  if (!DATE_ONLY.test(trimmed)) {
    return trimmed;
  }

  const [ys, ms, ds] = trimmed.split('-');
  const y = Number(ys);
  const m = Number(ms) - 1;
  const d = Number(ds);
  const pickerDate = new Date(y, m, d);

  if (bound === 'from') {
    return toScheduledFromIsoFromPickerDate(pickerDate);
  }

  return toScheduledToIsoFromPickerDate(pickerDate);
}
